<script setup>
    import {globalStore} from "@pinia/global-store";
    import {computed, onMounted, onUnmounted, ref} from "vue";
    import {getCookie, setCookie} from "@util/cookies";

    const mediaQuery = window.matchMedia("(max-width: 1080px)")
    const store = globalStore();

    const {
        addToHomeScreenText,
        closeText,
        desktopText,
        icon,
        iconWhite,
    } = ADDTODESKTOP;

    const cookieName = 'mobilePwaBannerClosed'
    const promptDismissed = ref(getCookie(cookieName))
    const addToDesktopClosed = ref(false);
    const deferredPrompt = ref(null)
    const viewport = computed(() => store.viewport);

    onMounted(() => {
        window.addEventListener('beforeinstallprompt', registerDeferredPrompt)

        mediaQuery.addEventListener('change', updateViewport)
        updateViewport(mediaQuery)
    })

    /**
     * Unregister these events so that they may be rebound
     * when the mobile version appears
     */
    onUnmounted(() => {
        mediaQuery.removeEventListener('change', updateViewport)
        window.removeEventListener('beforeinstallprompt', registerDeferredPrompt)
    })

    /**
     * Updates the view port based on the browsers resizing event
     * and hides the component for the Add To Desktop that isn't
     * being used
     *
     * @param mediaQuery
     */
    const updateViewport = (mediaQuery) => {
        const desktopApp = document.querySelector('#vue-nav-add-to-desktop .add-to-desktop');
        const mobileApp = document.querySelector('#vue-mobile-util-add-to-desktop .add-to-desktop');
        const isMobile = mediaQuery.matches;

        // Update store viewport state
        const newViewport = isMobile ? 'mobile' : 'desktop';
        store.$patch({ viewport: newViewport });

        // Toggle visibility classes
        desktopApp?.classList.toggle('hide', isMobile);
        mobileApp?.classList.toggle('hide', !isMobile);
    };


    /**
     * Registration method to setup the scripts for the
     * "Install PWA" and defer the prompt in older versions
     * of supported browsers
     *
     * @param e
     */
    const registerDeferredPrompt = (e) => {
        e.preventDefault()
        deferredPrompt.value = e
    }

    /**
     * The callback to trigger the prompt to show
     * when the button is clicked to execute on it
     */
    const deferredPromptCallback = () => {
        // Show the prompt
        deferredPrompt.value.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.value.userChoice.then(choiceResult => {
            if (choiceResult.outcome === 'accepted') {
                /**
                 * If needed to do something else
                 *  with the selected choice
                 */
            }
        });
    }

    /**
     * Hides the Add to Desktop action
     * in the browser
     */
    const closeAddToDesktop = () => {
        setCookie(
            cookieName,
            true,
            {
                domain: window.location.hostname,
                secure: true,
                sameSite: "strict",
            }
        )

        addToDesktopClosed.value = true
    }

</script>

<template>
    <div
        v-if="!addToDesktopClosed && !promptDismissed"
        :class="`add-to-desktop ${viewport}-atd-container`"
    >
        <p>
            <button
                ref="addBtn"
                class="add-button"
                @click="deferredPromptCallback"
            >
                <span v-html="viewport === 'mobile' ? desktopText : addToHomeScreenText"/>
                <img
                    :src="viewport === 'desktop' ? iconWhite : icon"
                    :alt="desktopText"
                    :aria-label="desktopText"
                    role="img"
                />
            </button>
            <button
                v-if="viewport === 'mobile'"
                class="close-btn"
                @click="closeAddToDesktop"
            >
                <span>
                    <span class="line-1"/>
                    <span class="line-2"/>
                </span>
                {{ closeText }}
            </button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "Add To Desktop"
    }
</script>

<style lang="scss" scoped>

</style>
